import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "./axiosInstance";
import "./invoice.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { toast } from "react-toastify";
import logo from "../../assets/logoo.png";
import axios from "axios";
const Invoice = () => {
  const { id } = useParams();
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [competitions, setCompetitions] = useState(null);
  const [bankDetails, setBankDetails] = useState([]);
  const invoiceRef = useRef();
  const [sending, setSending] = useState(false);
  const [downloading, setDownloading] = useState(false);
  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        const res = await axiosInstance.get(`/polymatchregister/${id}`);
        console.log("✅ Invoice fetched:", res.data.data);
        setInvoice(res.data.data);
      } catch (error) {
        console.error("Error fetching invoice:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchInvoice();
  }, [id]);

  // Backend se competitions fetch karo
  useEffect(() => {
    const fetchCompetitions = async () => {
      try {
        const res = await axiosInstance.get("/polymatch_competitions"); // backend API
        setCompetitions(res.data.data); // assume data array aa raha hai
      } catch (err) {
        console.error("Failed to fetch competitions", err);
      }
    };
    fetchCompetitions();
  }, [id]);

  useEffect(() => {
    const fetchBankDetails = async () => {
      try {
        const res = await axiosInstance.get("/bankdetails");
        console.log("✅ Bank details fetched:", res.data);
        setBankDetails(res.data); // assume your backend returns the array you shared
      } catch (err) {
        console.error("Failed to fetch bank details", err);
      }
    };

    fetchBankDetails();
  }, []);


  // const handleDownloadPDF = async () => {
  //   const element = invoiceRef.current;
  //   const canvas = await html2canvas(element, { scale: 2 });
  //   const imgData = canvas.toDataURL("image/png");
  //   const pdf = new jsPDF("p", "mm", "a4");

  //   const pdfWidth = pdf.internal.pageSize.getWidth();
  //   const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  //   pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
  //   pdf.save(`Invoice_${invoice.Invoice_No || id}.pdf`);
  // };



  const handleDownloadPDF = async () => {
    try {
      setDownloading(true);
      console.log("Starting PDF generation...");
      const element = invoiceRef.current;

      const canvas = await html2canvas(element, {
        scale: 2.5,
        useCORS: true,
        logging: false,
        removeContainer: true,
        backgroundColor: "#ffffff",
      });

      console.log("Canvas created, converting to image...");
      const imgData = canvas.toDataURL("image/png");
      console.log("Creating PDF...");

      // ✅ Use dynamic height based on content to prevent cutoff
      const pdfWidth = 210; // A4 width in mm
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      const pdf = new jsPDF("p", "mm", [pdfWidth, pdfHeight]);

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight, undefined, "SLOW");

      console.log("Generating base64...");
      const pdfBase64 = pdf.output("datauristring").split(",")[1];

      const sizeInMB = (pdfBase64.length * 0.75) / (1024 * 1024);
      console.log("📄 PDF size:", sizeInMB.toFixed(2), "MB");

      if (sizeInMB > 5) {
        toast.error("PDF is too large! Try reducing content.");
        return;
      }

      console.log("Sending to backend...");
      const response = await axiosInstance.post(
        "/saveInvoicePDF",
        {
          pdfBase64,
          fileName: `${invoice.Invoice_No || id}-${invoice.First_name}.pdf`,
        },
        {
          timeout: 120000,
          maxContentLength: 50 * 1024 * 1024,
          maxBodyLength: 50 * 1024 * 1024,
        }
      );

      console.log("✅ Success! Response:", response.data);

      // ✅ Also trigger local browser download
      pdf.save(`${invoice.Invoice_No || id}-${invoice.First_name}.pdf`);

      toast.success(
        `PDF Generated & Saved Successfully!`
      );
    } catch (err) {
      console.error("❌ Error saving PDF:", err);
      // ... (lines 130-143)
    } finally {
      setDownloading(false);
    }
  };

  const handleSendInvoice = async () => {
    if (!invoice) {
      toast.error("No invoice data found");
      return;
    }

    setSending(true);
    try {
      const response = await axiosInstance.post("/send-invoice", {
        invoiceNumber: invoice.Invoice_No || id,
        email: invoice.Email,
        First_name: invoice.First_name,
      });

      if (response.status === 200) {
        toast.success("Invoice sent to " + invoice.Email + " successfully!");
      } else {
        toast.error("Failed to send invoice");
      }
    } catch (error) {
      console.error("Error sending invoice:", error);
      toast.error(error.response?.data?.error || "Something went wrong while sending invoice");
    } finally {
      setSending(false);
    }
  };



  if (loading) return <div className="invoice-loading">Loading invoice...</div>;
  if (!invoice) return <div className="invoice-error">No invoice found.</div>;

  const competition = competitions?.find(c => c?.Competition_Id === invoice?.Competition_Id);
  const competitionName = competition ? competition.Competition_Name : "N/A";

  const competitionYear = competition && competition?.Competition_date
    ? new Date(competition?.Competition_date).getFullYear()
    : '';

  return (
    <div className="invoice-view-wrapper">
      {/* ✅ Invoice box */}
      <div className="invoice-box" ref={invoiceRef}>
        <div className="invoice-header">
          <img src={logo} alt="Polymath Kids Logo" className="invoice-logo" />
          <div className="invoice-number">
            <p>INVOICE NO.{invoice.Invoice_No || id}</p>
          </div>
        </div>
        <div className="invoice-header-centered">
          <h2 className="invoice-title">
            POLYMATCH {competitionName} ({competitionYear})
          </h2>
          <p className="invoice-child-name">
            <strong>Child name:</strong> {invoice.First_name} {invoice.Last_name} {invoice.Age ? `(${invoice.Age} years)` : ""}
          </p>
          <p className="invoice-username">
            <strong>User Name:</strong> {invoice.Username}
          </p>
        </div>

        <div className="invoice-dates">
          <p className="issue-date">
            <strong>Date:</strong>{" "}
            {(() => {
              const date = new Date(invoice.Issue_Date);
              const isPaid = invoice.Payment_Recieved === 1 || invoice.Payment_Recieved === true;

              // If date is valid and not 1970, show it
              if (!isNaN(date.getTime()) && date.getFullYear() > 1970) {
                return date.toLocaleDateString();
              }

              // Fallback logic for missing dates
              if (isPaid) return "-";
              return new Date().toLocaleDateString(); // Today as final fallback for Pending
            })()}
          </p>
          <p className="due-date">
            <strong>Due Date:</strong>{" "}
            {(() => {
              const dueDate = new Date(invoice.Due_Date);
              const isPaid = invoice.Payment_Recieved === 1 || invoice.Payment_Recieved === true;

              // If date is valid and not 1970, show it
              if (!isNaN(dueDate.getTime()) && dueDate.getFullYear() > 1970) {
                return dueDate.toLocaleDateString();
              }

              // Fallback if missing
              if (isPaid) return "-";
              const fallbackDue = new Date();
              fallbackDue.setDate(fallbackDue.getDate() + 2);
              return fallbackDue.toLocaleDateString();
            })()}
          </p>
        </div>

        <div className="invoice-billing">
          <div className="invoice-billing-left">
            <h4 className="billed">Billed to:</h4>
            <p className="Parent_name">
              {invoice.Parent_name}
            </p>
            <p className="contact-num">{invoice.Contact_Num}</p>
            <p className="email">{invoice.Email}</p>
            <p className="city">
              {invoice.City}, {invoice.Country}
            </p>
          </div>
          <div className="invoice-billing-right">
            <h4 className="from">From:</h4>
            <p className="poly">Polymath-Kids.com</p>
            <p className="number">+4747650619 / +1 (774) 254-5927</p>
            <p className="mail">info@polymath-kids.com</p>
          </div>
        </div>

        <table className="invoice-table">
          <thead>
            <tr>
              <th>Item</th>
              <th>Quantity</th>
              <th>Price</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{invoice.Competition_Name}</td>
              <td>1</td>
              <td>
                {(() => {
                  // Priority: 1. Database amount, 2. SessionStorage, 3. Environment variable
                  if (invoice.amount) return invoice.amount;

                  const pkr = sessionStorage.getItem("PKR");
                  const usd = sessionStorage.getItem("USD");
                  if (pkr) return pkr;
                  if (usd) return usd;
                  return invoice.Country?.toLowerCase() === "pakistan"
                    ? (process.env.REACT_APP_Amount_In_PKR || "0.00")
                    : (process.env.REACT_APP_Amount_In_USD || "0.00");
                })()}
              </td>
              <td>
                {(() => {
                  // Priority: 1. Database amount, 2. SessionStorage, 3. Environment variable
                  if (invoice.amount) return invoice.amount;

                  const pkr = sessionStorage.getItem("PKR");
                  const usd = sessionStorage.getItem("USD");
                  if (pkr) return pkr;
                  if (usd) return usd;
                  return invoice.Country?.toLowerCase() === "pakistan"
                    ? (process.env.REACT_APP_Amount_In_PKR || "0.00")
                    : (process.env.REACT_APP_Amount_In_USD || "0.00");
                })()}
              </td>
            </tr>

            <tr>
              <td>Transaction Charges</td>
              <td></td>
              <td>
                {(() => {
                  const pkr = sessionStorage.getItem("PKR");
                  const usd = sessionStorage.getItem("USD");
                  if (pkr) return (sessionStorage.getItem("PKRT") || process.env.REACT_APP_Transaction_Fee_PKR || "0.00");
                  if (usd) return (sessionStorage.getItem("USDT") || process.env.REACT_APP_Transaction_Fee_USD || "0.00");
                  return invoice.Country?.toLowerCase() === "pakistan"
                    ? (sessionStorage.getItem("PKRT") || process.env.REACT_APP_Transaction_Fee_PKR || "0.00")
                    : (sessionStorage.getItem("USDT") || process.env.REACT_APP_Transaction_Fee_USD || "0.00");
                })()}
              </td>
              <td>
                {(() => {
                  const pkr = sessionStorage.getItem("PKR");
                  const usd = sessionStorage.getItem("USD");
                  if (pkr) return (sessionStorage.getItem("PKRT") || process.env.REACT_APP_Transaction_Fee_PKR || "0.00");
                  if (usd) return (sessionStorage.getItem("USDT") || process.env.REACT_APP_Transaction_Fee_USD || "0.00");
                  return invoice.Country?.toLowerCase() === "pakistan"
                    ? (sessionStorage.getItem("PKRT") || process.env.REACT_APP_Transaction_Fee_PKR || "0.00")
                    : (sessionStorage.getItem("USDT") || process.env.REACT_APP_Transaction_Fee_USD || "0.00");
                })()}
              </td>
            </tr>
          </tbody>
        </table>

        <div className="invoice-totals">
          {(() => {
            const pkr = sessionStorage.getItem("PKR");
            const usd = sessionStorage.getItem("USD");
            const isPKR = pkr ? true : (usd ? false : (invoice.Country?.toLowerCase() === "pakistan"));

            const parseCurrency = (val, fallback = 0) => {
              if (!val) return fallback;
              const num = parseFloat(val.toString().replace(/[^0-9.]/g, ""));
              return !isNaN(num) ? num : fallback;
            };

            if (isPKR) {
              // Priority: 1. Database amount, 2. SessionStorage, 3. Environment variable
              const baseAmount = invoice.amount
                ? parseCurrency(invoice.amount, 0)
                : parseCurrency(pkr, parseCurrency(process.env.REACT_APP_Amount_In_PKR, 0));
              const transactionFee = parseCurrency(sessionStorage.getItem("PKRT"), parseCurrency(process.env.REACT_APP_Transaction_Fee_PKR, 0));
              const total = baseAmount + transactionFee;
              return (
                <>
                  <p><strong className="subtotal">Sub Total</strong> <span className="subtotal-amount">PKR {total.toLocaleString()}</span></p>
                  <p className="total"><strong className="totalpayable">Total Payable</strong> <span className="totalpayable-amount">PKR {total.toLocaleString()}</span></p>
                </>
              );
            } else {
              // Priority: 1. Database amount, 2. SessionStorage, 3. Environment variable
              const baseAmount = invoice.amount
                ? parseCurrency(invoice.amount, 0)
                : parseCurrency(usd, parseCurrency(process.env.REACT_APP_Amount_In_USD, 0));
              const transactionFee = parseCurrency(sessionStorage.getItem("USDT"), parseCurrency(process.env.REACT_APP_Transaction_Fee_USD, 0));
              const total = baseAmount + transactionFee;
              return (
                <>
                  <p><strong className="subtotal">Sub Total</strong> <span className="subtotal-amount">USD {total.toFixed(2)}</span></p>
                  <p className="total"><strong className="totalpayable">Total Payable</strong> <span className="totalpayable-amount">USD {total.toFixed(2)}</span></p>
                </>
              );
            }
          })()}
        </div>

        <div className="invoice-payment-staggered">

          {(() => {
            const pkr = sessionStorage.getItem("PKR");
            const usd = sessionStorage.getItem("USD");

            // Robust logic: Check session (if valid), else fall back to Country
            // Explicitly handle "undefined" and "null" strings which appear in session storage sometimes
            const hasSessionPKR = pkr && pkr !== "undefined" && pkr !== "null";
            const hasSessionUSD = usd && usd !== "undefined" && usd !== "null";

            let isPKR = false;

            if (hasSessionPKR) {
              isPKR = true;
            } else if (hasSessionUSD) {
              isPKR = false;
            } else {
              // Fallback to Country if session is empty (e.g. direct link)
              isPKR = invoice.Country?.trim().toLowerCase() === "pakistan";
            }

            console.log("Payment Method Debug:", {
              pkrSession: pkr,
              usdSession: usd,
              country: invoice.Country,
              isPKR
            });

            if (isPKR) {
              return (
                <div className="payment-details">
                  <p className="heading" style={{ textAlign: 'left' }}><strong>Payment method:</strong></p>
                  <div className="details">
                    {invoice.bank_id && invoice.bank_id.length > 0 && bankDetails.length
                      ? bankDetails
                        .filter(b => invoice.bank_id.includes(b.id.toString()))
                        .map((b, idx) => (
                          <div key={b.id} style={{ marginBottom: '15px' }}>
                            {b.details.split(";").map((line, index) => (
                              <p key={b.id + "-" + index}>{line.trim()}</p>
                            ))}
                          </div>
                        ))
                      : (
                        <p style={{ color: '#999' }}>No payment method selected</p>
                      )
                    }
                  </div>
                </div>
              );
            } else {
              return (
                <div className="payment-details">
                  <p className="heading" style={{ textAlign: 'left' }}><strong>Payment method:</strong></p>
                  <div className="details">
                    {invoice.bank_id && invoice.bank_id.length > 0 && bankDetails.length
                      ? bankDetails
                        .filter(b => invoice.bank_id.includes(b.id.toString()))
                        .map((b, idx) => (
                          <div key={b.id} style={{ marginBottom: '15px' }}>
                            {b.details.split(";").map((line, index) => (
                              <p key={b.id + "-" + index}>{line.trim()}</p>
                            ))}
                          </div>
                        ))
                      : (
                        <>
                          <p>Bank Name: Abu Dhabi Commercial Bank PJSC</p>
                          <p>Account Title: FAISAL FAROOQ</p>
                          <p>Account Number: 13177549820001</p>
                          <p>IBAN: AE14030013177549820001</p>
                          <p>Currency: AED</p>
                          <p>Branch: IBD - BUSINESS BAY BRANCH</p>
                          <p>Swift Code: ADCBAEAA</p>
                        </>
                      )
                    }
                  </div>
                  <br />
                  <p className="note">
                    Payment link will also be shared on your WhatsApp, if you <br />
                    wish to pay through Debit/Credit Card or PayPal.
                  </p>
                </div>
              );
            }
          })()}

          <div className="asterisk">
            <p style={{ fontStyle: 'italic' }}>*The amount of PolyMatch Competitions are non refundable and non transferable</p>
          </div>
        </div>

      </div>

      {/* ✅ Buttons section — Moved to bottom */}
      <div className="invoice-buttons">
        <button
          className="btn-download"
          onClick={handleDownloadPDF}
          disabled={downloading}
        >
          {downloading ? "Downloading..." : "Download PDF"}
        </button>
        <button
          className="btn-send"
          onClick={handleSendInvoice}
          disabled={sending}
        >
          {sending ? "Sending..." : "Send Invoice On Mail"}
        </button>
      </div>
    </div >
  );
};

export default Invoice;
